import { render, staticRenderFns } from "./GroupDistributionList.vue?vue&type=template&id=27caff0b"
import script from "./GroupDistributionList.vue?vue&type=script&lang=js"
export * from "./GroupDistributionList.vue?vue&type=script&lang=js"
import style0 from "./GroupDistributionList.vue?vue&type=style&index=0&id=27caff0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports